import { render, staticRenderFns } from "./NewClassTimeCard.vue?vue&type=template&id=5fe705d6"
import script from "./NewClassTimeCard.vue?vue&type=script&lang=js"
export * from "./NewClassTimeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports